import Header from "./components/header/header";

function App() {
  return (
    <div>
      <Header/>

    </div>
  );
}

export default App;
